import { sectionRoutes } from '../helpers';

export const IAM_CONSOLE_ROUTES = [
  ...sectionRoutes({
    meta: { adminTab: 'IAM Console' },
    tabKey: 'iamTab',
    routes: [
      ['iam-console/users', 'AdminIAMUsers', 'users'],
      ['iam-console/roles', 'AdminIAMRoles', 'roles'],
      ['iam-console/audit', 'AdminIAMAudit', 'audit'],
    ],
  }),
  {
    path: 'iam-console/users/:id',
    name: 'AdminIAMUserDetail',
    component: () => import('@/components/Overview/Overview_Admin_User.vue'),
    props: true,
    meta: { canAccess: 'module_admin', requiresAuth: true, layout: 'default' },
  },
];
